import { render, staticRenderFns } from "./jsQR.vue?vue&type=template&id=31e54a2e"
import script from "./jsQR.vue?vue&type=script&lang=js"
export * from "./jsQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports